/**
 * description:
 * Standalone page for the Scholarship section
 */

import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';
import EyebrowLabel from "../../../utils/EyebrowLabel";
import { mustard } from "../../../styles.tsx";
import PageHero from "../../../utils/PageHero";
import scholarshipHero from "../../../pictures/Hero/ScholarshipHero.svg";

const applyLink = "https://vt.academicworks.com/opportunities/10121?fbclid=IwAR3wpNb2teIO0ZdqL9Hx1laQ0cntN1Kekj3n9BwXkDP7PJJbMMT1CuZxyJA";

function ScholarshipPage() {
  const [story, setStory] = useState("");

  useEffect(() => {
    fetch('/textfiles/ScholarShip.txt')
      .then((response) => response.text())
      .then((text) => {
        const paragraphs = text.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
        // first paragraph is just the name (already in the hero), last is the CTA prompt (replaced below)
        setStory(paragraphs.slice(1, -1).join("\n\n"));
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <>
      <PageHero
        image={scholarshipHero}
        viewBoxWidth={1909}
        viewBoxHeight={378}
        cropHeight={378}
        bandColor="#F2C94C"
        accessibleTitle='The Rhonyll "Bong" Seballos Scholarship'
        pt={{ xs: "78px", sm: "76px", md: "90px", lg: "100px" }}
        width={{ xs: "94vw", sm: "620px", md: "760px", lg: "1200px", xl: "1383px" }}
      />

      <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "56px", md: "90px" } }}>
        <Box
          sx={{
            maxWidth: "820px",
            mx: "auto",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: "10px 10px 0 #ad5d4e",
            p: { xs: "28px", md: "56px" },
          }}
        >
          <EyebrowLabel color="secondary.main" sx={{ fontSize: { xs: "1.4rem", md: "1.7rem" } }}>His Story</EyebrowLabel>
          <Typography
            variant="body1"
            sx={{
              mt: "16px",
              whiteSpace: "pre-wrap",
              fontSize: { xs: "1.05rem", md: "1.15rem" },
              lineHeight: 1.7,
            }}
          >
            {story}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, py: { xs: "56px", md: "80px" }, textAlign: "center" }}>
        <Typography variant="h2" sx={{ color: mustard, mb: "20px" }}>
          Apply Today
        </Typography>
        <Typography variant="body1" sx={{ color: "background.paper", maxWidth: "560px", mx: "auto", mb: "32px" }}>
          Learn more about eligibility, requirements, and how to submit your application.
        </Typography>
        <Button
          href={applyLink}
          target="_blank"
          rel="noopener"
          variant="contained"
          color="secondary"
          endIcon={<SendIcon />}
          sx={{ px: "32px", py: "14px" }}
        >
          <Typography variant="h6" sx={{ color: "background.default" }}>
            Apply for the Scholarship
          </Typography>
        </Button>
      </Box>
    </>
  );
}

export default ScholarshipPage;
